'use client';

import FormCheckbox from '@/components/form/FormCheckbox/FormCheckbox';
import { Route } from 'next';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';

function ECommerceHasStockCheckForm({
  hasStock = false,
}: {
  hasStock?: boolean;
}) {
  const router = useRouter();
  const { getValues, control } = useForm({
    mode: 'onChange',
    defaultValues: {
      hasStock: hasStock ? ['hasStock'] : [],
    },
  });

  const onChangeCheck = () => {
    const params = new URLSearchParams(location.search);
    if (getValues('hasStock').length > 0) {
      params.set('hasStock', String(true));
    } else {
      params.delete('hasStock');
    }
    router.replace(`${location.pathname}?${params.toString()}` as Route);
  };

  return (
    <FormCheckbox
      name='hasStock'
      items={[
        {
          value: 'hasStock',
          child: <>在庫があるデジタルコンテンツのみを表示</>,
        },
      ]}
      control={control}
      onChange={onChangeCheck}
    />
  );
}

export default ECommerceHasStockCheckForm;
